import { Description } from '@mui/icons-material'
import { Button } from '@mui/material'
import { setMediaDetailsState } from '@/features/media-details/slice'
import type { SearchResultItem } from '@/features/search/types'
import { useAppDispatch } from '@/redux/hooks'

type Props = {
  searchItem: SearchResultItem
}

export const MediaDetails = (props: Props) => {
  const { searchItem } = props
  const dispatch = useAppDispatch()

  return (
    <Button
      onClick={() => {
        dispatch(
          setMediaDetailsState({
            openDrawer: true,
            searchResultItem: searchItem,
          }),
        )
      }}
      key="media-details"
      title="Media Details"
    >
      <Description />
    </Button>
  )
}
